'use client';
import * as e from 'react';
import { CarouselSlide } from '../carousel/carousel-slide.component.js';
import { renderWithRef } from '../core/render-with-ref.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
const ThumbnailsHeroVideoThumbnailSlide = renderWithRef('ThumbnailsHeroVideoThumbnailSlide', null, (t, n)=>e.createElement(CarouselSlide, _object_spread({
        ref: n
    }, t), e.createElement("span", {
        className: "swan-thumbnails-hero-thumbnail-play-icon"
    }), t.children));

export { ThumbnailsHeroVideoThumbnailSlide };
